export default __webpack_public_path__ + "static/media/background-light-1.b503eea5.jpg";